var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.982 18.156a.5.5 0 0 0 .725.688l-.363-.344.363.344.001-.001.003-.003.01-.01.043-.046.187-.197.865-.913 4.396-4.64a1.503 1.503 0 0 0 .003-2.066l-5.508-5.812a.5.5 0 0 0-.726.688l5.36 5.656H2.5a.5.5 0 0 0 0 1h17.84l-4.25 4.486-.865.913-.187.197-.043.046-.01.01zl.362.344z",
    clipRule: "evenodd"
  })));
});
const SvgArrowRight = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC45ODE1IDE4LjE1NjFDMTQuNzkxNiAxOC4zNTY1IDE0LjgwMDEgMTguNjczIDE1LjAwMDUgMTguODYyOUMxNS4yMDEgMTkuMDUyOSAxNS41MTc0IDE5LjA0NDQgMTUuNzA3NCAxOC44NDM5TDE1LjM0NDQgMTguNUwxNS43MDc0IDE4Ljg0MzlMMTUuNzA3NCAxOC44NDM5TDE1LjcwNzYgMTguODQzN0wxNS43MDgyIDE4Ljg0M0wxNS43MTA3IDE4Ljg0MDRMMTUuNzIxIDE4LjgyOTVMMTUuNzY0MSAxOC43ODRMMTUuOTUxMSAxOC41ODY3TDE2LjgxNiAxNy42NzM5TDIxLjIxMiAxMy4wMzQ1QzIxLjc1ODYgMTIuNDU3NyAyMS43NjQ1IDExLjU0ODYgMjEuMjE0NiAxMC45NjgzTDE1LjcwNzQgNS4xNTYxQzE1LjUxNzQgNC45NTU2NSAxNS4yMDEgNC45NDcxMiAxNS4wMDA1IDUuMTM3MDZDMTQuODAwMSA1LjMyNjk5IDE0Ljc5MTYgNS42NDM0NiAxNC45ODE1IDUuODQzOTFMMjAuMzQwOSAxMS41SDIuNUMyLjIyMzg2IDExLjUgMiAxMS43MjM5IDIgMTJDMiAxMi4yNzYxIDIuMjIzODYgMTIuNSAyLjUgMTIuNUgyMC4zNDA4TDE2LjA5MDEgMTYuOTg2MUwxNS4yMjUyIDE3Ljg5ODlMMTUuMDM4MiAxOC4wOTYyTDE0Ljk5NTIgMTguMTQxN0wxNC45ODQ4IDE4LjE1MjZMMTQuOTgyMyAxOC4xNTUyTDE0Ljk4MTcgMTguMTU1OUwxNC45ODE1IDE4LjE1NkwxNC45ODE1IDE4LjE1NjFMMTUuMzQ0NCAxOC41TDE0Ljk4MTUgMTguMTU2MVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";